export const ROLE_HOME_PATHS = {
  admin: "/issuer/discover",
  finance_admin: "/issuer/finance",
  issuer: "/issuer/discover",
  approver: "/issuer/discover/approvals",
  programme_approver: "/issuer/discover/approvals",
  tenant_admin: "/issuer/discover/approvals",
  tenant_user: "/issuer/discover/approvals",
  super_admin: "/issuer/tenant",
};

export const getRoleHomePath = (userRole) => {
  const normalizedRole = userRole?.toLowerCase?.() || null;
  return ROLE_HOME_PATHS[normalizedRole] || "/issuer/discover";
};

export const normalizeIssuerPath = (pathname = "") => {
  const match = String(pathname).match(/^\/issuer\/?(.*)$/);
  if (!match) {
    return "";
  }
  return (match[1] || "").replace(/\/+$/, "");
};

export const isIssuerPathAllowed = (currentPath, allowedPaths = []) => {
  const normalizedCurrentPath = (currentPath || "").replace(/\/+$/, "");

  return allowedPaths.some((allowedPath) => {
    if (allowedPath === normalizedCurrentPath) {
      return true;
    }
    if (allowedPath.includes(":")) {
      const regex = new RegExp(
        `^${allowedPath.replace(/:[^/]+/g, "[^/]+")}$`,
      );
      return regex.test(normalizedCurrentPath);
    }
    return false;
  });
};
